import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from '@mui/material';
import { Close as CloseIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import ProductModal from './ProductModal';

export const PRIORITY_OPTIONS = [
  { value: '0', label: '0 - Only for Backoffice' },
  { value: '1', label: '1 - 1st Priority' },
  { value: '2', label: '2 - 2nd Priority' },
  { value: '3', label: '3 - To get you home' },
];

function ManageProductsModal({
  open,
  setOpen,
  products,
  handleDeleteProduct,
  openDeleteModal,
  setOpenDeleteModal,
  openProductModal,
  setOpenProductModal,
  modalMode,
  setModalMode,
  handleSave,
  dropDownValues,
}) {
  const [product, setProduct] = useState(null);

  const handleEdit = product => {
    setProduct(product);
    setModalMode('edit');
    setOpenProductModal(true);
  };

  const handleDelete = product => {
    setOpenDeleteModal(true);
    setProduct(product);
  };

  function handleAdd() {
    setProduct(products[0]);
    setModalMode('add');
    setOpenProductModal(true);
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: '90vh',
          },
        }}>
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h5" component="div">
              Manage Products
            </Typography>
            <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close" sx={{ color: 'grey.500' }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          {products && products.length > 0 ? (
            <TableContainer component={Paper} elevation={0}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: 'grey.100' }}>
                    <TableCell sx={{ fontWeight: 600 }}>Product Group</TableCell>
                    {/* <TableCell sx={{ fontWeight: 600 }}>Purchase Price</TableCell> */}
                    <TableCell sx={{ fontWeight: 600 }}>Destination</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Priority</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 600 }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {products.map(product => (
                    <TableRow
                      key={product.id}
                      sx={{
                        '&:hover': {
                          backgroundColor: 'grey.50',
                        },
                      }}>
                      <TableCell>{product.productGroup}</TableCell>
                      {/* <TableCell>{product.purchasePrice ?? 0}</TableCell> */}
                      <TableCell>{product.destination}</TableCell>
                      <TableCell>{product?.priority ?? '1st Priority'}</TableCell>
                      <TableCell align="center">
                        <Box display="flex" justifyContent="center" gap={1}>
                          <IconButton color="primary" size="small" onClick={() => handleEdit(product)} title="Edit">
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton color="error" size="small" onClick={() => handleDelete(product)} title="Delete">
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
              <Typography variant="body1" color="text.secondary">
                No products available
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={handleAdd} variant="contained" color="inherit">
            Add Product
          </Button>
          <Button onClick={handleClose} variant="contained" color="inherit">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* // Delete Modal */}
      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: { borderRadius: 3, p: 1 },
        }}>
        <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>Delete Product</DialogTitle>

        <DialogContent sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: '15px' }}>Are you sure you want to this Product</Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpenDeleteModal(false)} sx={{ textTransform: 'none' }}>
            Cancel
          </Button>

          <Button
            variant="contained"
            style={{ backgroundColor: '#FF2400', color: '#fff' }}
            onClick={() => handleDeleteProduct(product.id)}
            sx={{ textTransform: 'none' }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <ProductModal
        open={openProductModal}
        setOpen={setOpenProductModal}
        product={product}
        onSave={handleSave}
        mode={modalMode}
        dropDownValues={dropDownValues}
      />
    </>
  );
}

export default ManageProductsModal;
